import type {
  CreateTaxCodesMutationOptions,
  CreateTaxCodesPayload,
} from './types';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysTaxCode } from '../queryKeys';

import { createTaxCodes } from './createTaxCodes';

/**
 * Creates tax codes and refreshes both tax-code lists and filter options.
 *
 * @param options - Additional mutation options.
 * @returns The tax-code creation mutation.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const useMutationCreateTaxCodes = (
  options?: CreateTaxCodesMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateTaxCodesPayload) =>
      createTaxCodes(payload),
    ...options,
    onSettled(data, error, variables, onMutateResult, context) {
      void queryClient.invalidateQueries({
        queryKey: queryKeysTaxCode.getAll(),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeysTaxCode.filterOptions(),
      });

      return options?.onSettled?.(
        data,
        error,
        variables,
        onMutateResult,
        context,
      );
    },
  });
};
